import React, { useRef } from 'react';
import useAuthedImage from './useAuthedImage';
import { GOLD_LT } from '../theme';

export const MAX_BYTES = 8 * 1024 * 1024;
export const ACCEPTED_TYPES = ['image/jpeg', 'image/png', 'image/webp'];

export function fileToBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(String(reader.result).split(',')[1]);
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
}

export function ImageThumb({ image, size, urlFn }) {
  const src = useAuthedImage(image, urlFn);
  return (
    <div style={{ width: size, aspectRatio: '3 / 4', background: '#231a11', overflow: 'hidden', position: 'relative' }}>
      {src && <img src={src} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />}
    </div>
  );
}

export function UploadButton({ label, uploading, progress, multiple, onUpload }) {
  const inputRef = useRef(null);
  return (
    <>
      <input
        ref={inputRef}
        type="file"
        accept={ACCEPTED_TYPES.join(',')}
        multiple={multiple}
        style={{ display: 'none' }}
        onChange={(e) => {
          const files = Array.from(e.target.files || []);
          e.target.value = '';
          if (files.length) onUpload(files);
        }}
      />
      <button
        onClick={() => inputRef.current && inputRef.current.click()}
        disabled={uploading}
        style={{ fontSize: 12, letterSpacing: '.12em', textTransform: 'uppercase', color: GOLD_LT, background: 'none', border: `1px solid ${GOLD_LT}`, padding: '8px 14px', cursor: uploading ? 'default' : 'pointer', opacity: uploading ? .6 : 1 }}
      >
        {uploading ? `Uploading${progress ? ` ${progress}` : '…'}` : label}
      </button>
    </>
  );
}

export function validateFiles(files, setError) {
  return files.filter((file) => {
    if (!ACCEPTED_TYPES.includes(file.type)) {
      setError('Only JPG, PNG, or WEBP images are supported.');
      return false;
    }
    if (file.size > MAX_BYTES) {
      setError('Images must be under 8MB.');
      return false;
    }
    return true;
  });
}
